import {
  IntegerFilterInput,
  SortOrder,
} from '@moonpig/web-explore-types-graphql'
import { SearchCriteria } from '@moonpig/web-shared-products'
import { SearchRequestResponse } from '../../../services'
import {
  ApplicableFilter,
  FilterItem,
  SearchFilter,
} from '../../../services/types/services'
import { FilteringEvent } from '../../../types'

export type QueryProductsProps = {
  newPage: number
  isLoadMore?: boolean
  isPrevious?: boolean
  isLoadPage?: boolean
  filters?: ApplicableFilter[]
  sortOrder?: SortOrder
  filteringEvent?: FilteringEvent
  allFilters?: FilterItem[]
  integerFilter?: IntegerFilterInput
}

type ProductsStateProps = {
  initialOffset: number
  topPage: number
  bottomPage: number
  lastLoadedPage: number
  galleryPageSize: number
  results: SearchRequestResponse
  searchCriteria: SearchCriteria
  querySearch:
    | null
    | ((queryParams: {
        newPage: number
        filters: SearchFilter[]
        integerFilter?: IntegerFilterInput
        sortOrder: SortOrder | undefined
      }) => Promise<SearchRequestResponse>)
}

export enum PageNavigationSource {
  Next = 'next',
  Previous = 'previous',
  Number = 'number',
  History = 'history',
}

type ProductsStateDispatchers = {
  resetInitialOffset: VoidFunction
  loadMoreProducts: (isPrevious?: boolean) => Promise<boolean>
  loadPage: (page: number, source: PageNavigationSource) => Promise<void>
  queryProducts: (searchTypeProps: QueryProductsProps) => void
  resetPage: () => void
}

export type ProductsState = ProductsStateProps & ProductsStateDispatchers
